import React from "react";

import dayjs from "dayjs";
import { DoneCheck, Close } from "icons";

import { Tag } from "clearsense-ui/components";
import ActionDropdown from "components/Common/ActionDropdown";
import { LinkText, Steward } from "components/Common/TableStyle";

const getStatusColor = text => {
  switch (text) {
    case "Ingested":
      return "#EBF4EC";
    case "Profiled":
      return "#FDF0E3";
    case "Scanned":
      return "#FAEAEA";
    default:
      return "";
  }
};

const getStatusIcon = text => (text === "Failed" ? Close : DoneCheck);

export const DATA_SOURCE_COLUMNS = (
  handleEdit,
  handleDelete,
  userPermissions
) => [
  {
    title: "Name",
    key: "name",
    fixed: "left",
    dataIndex: "name",
    width: 150,
    render: (text, row) => (
      <LinkText text={text} link={row.id} state={{ parent: text }} />
    ),
  },
  {
    title: "Description",
    key: "description",
    width: 350,
    dataIndex: "description",
  },
  {
    title: "Type",
    key: "db_name",
    dataIndex: "db_name",
    width: 100,
    render: () => "RDBMS",
  },
  {
    title: "DS Status",
    key: "status",
    dataIndex: "status",
    width: 150,
    render: text =>
      text ? (
        <Tag
          label={text}
          color={getStatusColor(text)}
          icon={getStatusIcon(text)}
          className="flex-row-reverse "
        />
      ) : (
        <Tag
          label="Ingested"
          color={getStatusColor("Ingested")}
          icon={getStatusIcon("Ingested")}
          className="flex-row-reverse "
        />
      ),
  },
  {
    title: "Total Data Source Data Elements",
    key: "data_elements",
    width: 200,
    dataIndex: "data_elements",
  },
  {
    title: "# Incomplete Data source data elements",
    key: "mapped_elements",
    width: 200,
    dataIndex: "mapped_elements",
    render: (text, record) =>
      record.data_elements === 0 ? "-" : record.data_elements - text,
  },
  {
    title: "Drafter",
    key: "drafter",
    width: 200,
    dataIndex: "drafter",
    render: text => <Steward name={text?.name} title={text?.role} />,
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    render: text => <Steward name={text?.name} title={text?.role} />,
    width: 200,
  },
  {
    title: "Last Updated",
    key: "updated_at",
    dataIndex: "updated_at",
    width: 150,
    render: text => dayjs(text).format("YYYY/MM/DD HH:mm"),
  },
  {
    title: "Action",
    key: "edit",
    width: 100,
    align: "center",
    render: (_, record) => (
      <ActionDropdown
        editProps={{ onClick: () => handleEdit(record.id) }}
        deleteProps={{
          onClick: () => handleDelete(record),
          "data-cy": "cde-delete-button",
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];

export const QUICK_FILTER_DATA = [
  {
    label: "Missing Descriptions",
    value: 2,
  },
  {
    label: "Incomplete Mapping",
    value: 4,
  },
  {
    label: "Last 60 Days",
    value: 2,
  },
];

export const CHART_DATA = [
  {
    name: "Medication",
    Unmapped: 30,
    Mapped: 15,
  },
  {
    name: "Provider",
    Unmapped: 54,
    Mapped: 20,
  },
  {
    name: "Claims",
    Unmapped: 32,
    Mapped: 23,
  },
  {
    name: "Hospital",
    Unmapped: 22,
    Mapped: 45,
  },
];
